import { PLUGIN_SEPARATOR } from "../Customization/PluginsManager/pluginFeatureUtils";

/**
 * Categorizes normalized app features into regular features and plugin groups.
 *
 * Plugin features are identified by the "::" separator in their name.
 * Splitting is done on the first "::" only — subsequent "::" remain part of the feature key.
 *
 * @param {Object} normalizedAppFeatures - Map of { featureName: { read, create, update, delete } }
 * @returns {{ regularFeatures: Object, pluginGroups: Object }}
 *   - regularFeatures: features without "::" in their name
 *   - pluginGroups: { [pluginName]: { [featureKey]: { read, create, update, delete } } }
 */
export function categorizeFeatures(normalizedAppFeatures) {
  const regularFeatures = {};
  const pluginGroups = {};

  if (!normalizedAppFeatures || typeof normalizedAppFeatures !== "object") {
    return { regularFeatures, pluginGroups };
  }

  for (const featureName of Object.keys(normalizedAppFeatures)) {
    const separatorIndex = featureName.indexOf(PLUGIN_SEPARATOR);

    if (separatorIndex !== -1) {
      const pluginName = featureName.substring(0, separatorIndex);
      const featureKey = featureName.substring(separatorIndex + PLUGIN_SEPARATOR.length);

      if (!pluginGroups[pluginName]) {
        pluginGroups[pluginName] = {};
      }
      pluginGroups[pluginName][featureKey] = normalizedAppFeatures[featureName];
    } else {
      regularFeatures[featureName] = normalizedAppFeatures[featureName];
    }
  }

  return { regularFeatures, pluginGroups };
}
